import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { ProductLine } from '@indutrust/factory-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * API client for the `product_lines` sub-resource nested under a factory
 * capability —
 * `/factories/{factoryId}/capabilities/{capabilityId}/product_lines`.
 *
 * Call inherited CRUD methods with
 * `urlSegments: { factoryId: <fid>, capabilityId: <cid> }`.
 */
@Service()
export class ProductLineApiClient extends BaseApiClient<ProductLine> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<ProductLine> = {};

  get url(): string {
    return `${this.envService.getApiUrl()}/factories/{factoryId}/capabilities/{capabilityId}/product_lines`;
  }
}
